var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkSingleEmail } from '@xylabs/sdk-coin-js';
import InfoWrapper from './InfoWrapper';
class ContactInfoWrapper extends InfoWrapper {
    constructor(value) {
        super('contactInfo', value);
    }
    getData() {
        return this.data;
    }
    getSanitizedData() {
        const result = JSON.parse(JSON.stringify(this.data));
        delete result.email;
        delete result.lastName;
        delete result.firstName;
        delete result.phone;
        return result;
    }
    setFirstName(value) {
        this.data.firstName = value;
        this.save();
        return this;
    }
    validateFirstName() {
        var _a, _b;
        if (((_b = (_a = this.data.firstName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 0) {
            return Error('First name may not be empty');
        }
    }
    setLastName(value) {
        this.data.lastName = value;
        this.save();
        return this;
    }
    validateLastName() {
        var _a, _b;
        if (((_b = (_a = this.data.lastName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 0) {
            return Error('Last name may not be empty');
        }
    }
    setEmail(value) {
        this.data.email = value;
        this.save();
        return this;
    }
    validateEmail(debounce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { error, suggestedEmail } = yield ContactInfoWrapper.validateEmail(this.data.email, debounce);
            this.suggestedEmail = suggestedEmail;
            return error;
        });
    }
    setPhone(value) {
        this.data.phone = value;
        this.save();
        return this;
    }
    validatePhone() {
        var _a, _b;
        if (((_b = (_a = this.data.phone) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 0) {
            return Error('Phone name may not be empty');
        }
    }
    errors() {
        return __awaiter(this, void 0, void 0, function* () {
            return [this.validateFirstName(), this.validateLastName(), yield this.validateEmail()].filter((item) => item !== undefined);
        });
    }
    static validateEmail(email, debounce) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!email || email.length === 0) {
                return { error: Error('Email may not be empty') };
            }
            if (debounce) {
                try {
                    const check = yield checkSingleEmail(email);
                    if (((_a = check.debounce) === null || _a === void 0 ? void 0 : _a.send_transactional) !== '1') {
                        return { error: Error('Email in invalid'), suggestedEmail: (_b = check.debounce) === null || _b === void 0 ? void 0 : _b.did_you_mean };
                    }
                }
                catch (ex) {
                    console.error(ex);
                }
            }
            return {};
        });
    }
}
export default ContactInfoWrapper;
//# sourceMappingURL=ContactInfoWrapper.js.map